exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cat-item[data-v-5e428f5c]{font-size:17px;min-height:40px;cursor:pointer}.food-img[data-v-5e428f5c]{border-radius:5px;-o-object-fit:cover;object-fit:cover;position:relative}.nowrap-text[data-v-5e428f5c]{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}.legends[data-v-5e428f5c]{margin-top:-3px;margin-bottom:-5px}.feature-icon-img[data-v-5e428f5c]{margin-left:4px}.sold-out-bg[data-v-5e428f5c]{position:absolute;top:0;left:0;background-color:hsla(0,0%,100%,.4);color:#fff;z-index:1}.sold-out-text[data-v-5e428f5c]{font-size:18px;color:#fff;background-color:#e34f4f;padding:3px 8px;-webkit-transform:rotate(-5deg);transform:rotate(-5deg)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5e428f5c","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ListCatItem.vue
// module id = qmok
// module chunks = 0